module.exports = __webpack_public_path__ + "img/nav4-active.fb3218fa.png";